/* eslint-disable array-callback-return */
import {
  getTrendReportFreightObject,
  getTrendReportInventoryObject
} from "./getTrendReportObject";

const formatTrendReportData = (data: any) => {
  const groupedData = data?.map((parentItem: any) => {
    const parentObject: any = {
      title: { value: parentItem.title },
      isGrossMarginCollapsibleRow: true,
      subtitleColumnNo: 1,
      key: parentItem?.key
    };

    if (parentItem?.key === "inventory") {
      parentObject.rowSubtitle = "grossMarginReport.retail";
    }

    const childRowItems = parentItem?.items?.map((childItem: any) => {
      if (parentItem?.key === "inventory") {
        return getTrendReportInventoryObject(childItem);
      }

      if (parentItem?.key === "freight") {
        return getTrendReportFreightObject(childItem);
      }
    });

    parentObject.childRowData = childRowItems;

    return parentObject;
  });

  const [parentItem] = data;
  const [childItem] = parentItem.items;

  const dateLabels = childItem?.inventoryCycles?.map((item: any) => item.name);
  const trendReportHighlights = childItem?.inventoryCycles?.map(
    (item: any) => !item.isFinalized
  );
  return { dateLabels, groupedData, trendReportHighlights };
};

export default formatTrendReportData;
